import React from "react";
import {Col, Row} from "reactstrap";
import Reset from "../containers/Reset";

const ThankYou = () => (
    <div className={"test-thank-you"}>
        <Row>
            <Col>
                <h3>Благодаря, че решихте да ми изпратите контактите си!</h3>
                <p>Ще се свържа с Вас при първа възможност</p>
                <ul>
                    <li>
                        <a href={"https://www.muzdrakova.com/"} title={"Към muzdrakova.com"}>Посетете сайта ми</a>, където ще намерите разнообразна информация за услугите, които предлагам
                    </li>
                    <li>
                        <Reset isLink={true} linkText={"Започни теста отначало"}/>
                    </li>
                </ul>
            </Col>
        </Row>
    </div>
);

export default ThankYou